import { render, staticRenderFns } from "./PinInputV2.vue?vue&type=template&id=fc5a996a"
import script from "./PinInputV2.vue?vue&type=script&lang=js"
export * from "./PinInputV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports